import { g as r } from "./generateUtilityClasses-CWIIr9E_.mjs";
const t = (e, s, a) => r(`${e}${s}`, a), g = (e, s) => t("Fabric", e, s);
export {
  t as a,
  g
};
//# sourceMappingURL=generate-fabric-classes-CDFy9xEs.mjs.map
